export const background = "#1198C4";
export const iconColor = "#ffffff";